var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.results && _vm.results.scores)?_c('div',{attrs:{"tabindex":"-1"}},[_vm._v("\n  "+_vm._s(_vm.simpleScore)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }